export const VARIATION = [
  'critical',
  'neutral',
  'success',
  'warning'
]
